import { useCallback, useEffect, useMemo, useState } from "react";
import { getSettings } from "@proxy/_utils";
import { setSdkData } from "../_utils";

const useGiftCardSettingsManager = ({
  previewSettings,
  preview,
  inDashboard,
  fulfillmentType
}: any) => {
  

  const [settings, setSettings]                     = useState<any>(null);
  const [translations, setTranslations]             = useState<any>(null);

  const [digitalEnabled, setDigitalEnabled] = useState<boolean>(false);
  const [physicalEnabled, setPhysicalEnabled] = useState<boolean>(false);


  /**
  * Load up the settings from the shop
  */
  useEffect(useCallback(() => {
    
    if (preview === true && previewSettings) {
      applySettings(previewSettings);
      return;
    }

    if (preview !== true) {

      getSettings()
      .then((s: any) => {
        applySettings(s);
      })
      .catch((error: any) => {
        console.error("Error loading settings", error);
      })
      ;

    }
    

  }, []), [previewSettings, fulfillmentType]);
  /**
   * Apply the initial state of the form.
   * @param {object} settings
   */
  const applySettings = (settings: any) => {

    const digitalEnabled     = (inDashboard) ? window.location.pathname.includes("digital") : (settings?.digital?.giftcard?.enable || false);
    const physicalEnabled    = (inDashboard) ? window.location.pathname.includes("physical") : ((settings?.physical?.giftcard?.enable && settings?.physical_printing_allowed) || false);
    
    setSettings(settings);
    setSdkData('settings', settings);
    setTranslations(settings.translations);
    setPhysicalEnabled(physicalEnabled);
    setDigitalEnabled(digitalEnabled);


  };

  const styleVars = settings && settings.global ? {
    "--gc__var-brand_color": settings.global.appearance.brand_color,
    "--gc__var-accent_color": settings.global.appearance.accent_color,
    "--gc__var-button_text_color": settings.global.appearance.button_text_color,
  } : {};

  const res = {
    settings,
    styleVars,
    translations,
    applySettings,
    digitalEnabled,
    physicalEnabled
  }

  return useMemo(() => res, [res]);


}

export default useGiftCardSettingsManager;